
    /* Ensure window.__INITIAL_STATE__ is defined before using it */
    if (window.__INITIAL_STATE__) {
      window.idleTimeout = window.__INITIAL_STATE__.lq2TimeTillIdle;
      window.idleTimer = window.__INITIAL_STATE__.lq2MinutesAfterTimeout;
      window.gaKey = window.__INITIAL_STATE__.loginGaKey;
      window.maxFileUploadSize = window.__INITIAL_STATE__.maxAllowedContentLength - window.__INITIAL_STATE__.networkPacketOverage;
      window.recaptchaOptions = {
        recaptchaKey: window.__INITIAL_STATE__.myLoanRecaptchaSiteKey
      };
    } else {
      console.error('window.__INITIAL_STATE__ is not defined.');
    }
  